import React from "react";
import { cn } from "../../lib/cn";

export interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: React.ReactNode;
  disabled?: boolean;
  id?: string;
  className?: string;
}

/** Token-styled checkbox. The real <input> is visually hidden (peer) and drives the box. */
export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  disabled,
  id,
  className,
}) => (
  <label
    className={cn(
      "inline-flex items-center gap-2 select-none",
      disabled ? "opacity-55 cursor-default" : "cursor-pointer",
      className,
    )}
  >
    <input
      type="checkbox"
      id={id}
      className="peer sr-only"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
    />
    <span
      className={cn(
        "w-[18px] h-[18px] rounded-[6px] border border-border bg-surface-2 grid place-items-center transition-colors",
        "peer-checked:bg-cyan peer-checked:border-cyan",
        "peer-focus-visible:shadow-[0_0_0_3px_rgba(39,182,203,.14)]",
        "[&_svg]:opacity-0 peer-checked:[&_svg]:opacity-100",
      )}
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3 text-cyan-ink">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </span>
    {label && <span className="text-[14px] text-body">{label}</span>}
  </label>
);

export default Checkbox;
